module.exports = __webpack_public_path__ + "static/media/19ESCAP4.d6ef3a39.jpg";